/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {
    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      // ✅ On lit le variant ID stable plutôt que la position line
      const variantId = $(this).closest('[data-variant-id]').data('variant-id');
      window.PXUTheme.jsCart.removeFromCart(variantId);
      return false;
    });

    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },

  removeFromCart: function (variantId) {
    // On trouve l'élément DOM via data-variant-id
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-variant-id="${variantId}"]`);

    // ── Détecte si c'est l'échantillon auto qui est supprimé ──
    const AUTO_SAMPLE_VARIANT_ID = window.MolinardConfig && window.MolinardConfig.autoSampleVariantId ? window.MolinardConfig.autoSampleVariantId : null;

    const AUTO_SAMPLE_DISMISSED_KEY = 'molinard_auto_sample_dismissed';

    if (AUTO_SAMPLE_VARIANT_ID) {
      const AUTO_SAMPLE_DISMISSED_KEY = 'molinard_auto_sample_dismissed';
      if (parseInt(variantId) === AUTO_SAMPLE_VARIANT_ID) {
        localStorage.setItem(AUTO_SAMPLE_DISMISSED_KEY, 'true');
      }
    }
    // ── Fin détection ─────────────────────────────────────────

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { quantity: 0, id: variantId }, // ✅ id stable, pas line
      dataType: 'json',
      success: function (cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, null);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest) {
        $cartItem.css('opacity', '1');
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },

  updateView: function (cart, lineID) {
    if (cart.item_count > 0) {
      $.ajax({
        dataType: 'html',
        async: false,
        cache: false,
        url: '/cart',
        success: function (html) {
          // Resynchronise les data-line-item après suppression
          const updatedItems = $(html).find('.cart__item-list .cart__card');
          const currentItems = $('.cart__item-list .cart__card');

          if (updatedItems.length != currentItems.length) {
            const updatedCartList = $(html).find('.cart__item-list');
            $('.cart__item-list').replaceWith(updatedCartList);
          }

          // Remet à jour les index line-item (utile pour quantity box)
          $(currentItems).each(function(index, element) {
            $(element).attr('data-line-item', (index + 1));
            $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
          });

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);
        }
      });
    } else {
      localStorage.removeItem('molinard_auto_sample_dismissed');
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }
  },

  unload: function ($section) {
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })();